import { MessageCircle } from "lucide-react";
import { fmtDate, fmtPhone, waLink, waTemplate } from "@/lib/helpers";
import { StatusBadge, Flags } from "./StatusBadge";

export function AppointmentList({ items, onSelect, academy }) {
  if (!items.length) return <p className="rounded-2xl bg-white border border-bej p-8 text-center text-slate-500" data-testid="list-empty">Bu aralıkta talep yok.</p>;
  return (
    <div className="rounded-2xl bg-white border border-bej overflow-x-auto" data-testid="appointment-list">
      <table className="w-full text-sm">
        <thead className="bg-bej-light text-left text-xs uppercase tracking-wider text-navy/70">
          <tr>
            {["Talep No", "Tarih / Saat", "Ad Soyad", "Telefon", "Kurs", "Öğrenci", "Durum", ""].map((h) => (
              <th key={h} className="px-4 py-3 font-bold whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((a) => (
            <tr key={a.id} onClick={() => onSelect(a)} data-testid={`list-row-${a.request_no}`}
              className={`border-t border-bej cursor-pointer transition-colors ${a.conflict ? "bg-red-50 hover:bg-red-100" : "hover:bg-cream"}`}>
              <td className="px-4 py-3 font-bold text-navy whitespace-nowrap">{a.request_no}</td>
              <td className="px-4 py-3 whitespace-nowrap">{fmtDate(a.date, { day: "numeric", month: "short", weekday: "short" })} · <b>{a.time}</b></td>
              <td className="px-4 py-3"><div className="font-semibold">{a.name}</div><Flags a={a} /></td>
              <td className="px-4 py-3 whitespace-nowrap">{fmtPhone(a.phone)}</td>
              <td className="px-4 py-3">{a.course_name}</td>
              <td className="px-4 py-3 whitespace-nowrap">{a.student_type === "cocuk" ? "Çocuk" : "Yetişkin"}{a.student_age ? `, ${a.student_age}` : ""}</td>
              <td className="px-4 py-3"><StatusBadge status={a.status} /></td>
              <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
                {a.phone && (
                  <a href={waLink(a.phone, waTemplate(a, academy))} target="_blank" rel="noreferrer" data-testid={`list-wa-${a.request_no}`}
                    className="inline-grid place-items-center w-9 h-9 rounded-full bg-[#25D366] text-white hover:brightness-95" title="WhatsApp">
                    <MessageCircle className="w-4 h-4" />
                  </a>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
